import { Component, NgZone, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import {
    DataArray,
    AuthorizationService,
    AccountService,
    AccountSetting,
    AccountSettingGroup,
    SecurityQuestion,
    ToastrService,
} from './../../../shared/index';
//import { CatalogService } from "./../../index";

@Component({
    selector: 'account-index',
    templateUrl: './account-index.html',
    standalone: false
})

export class AccountIndexComponent implements OnInit, OnDestroy {
    @ViewChild('changePasswordModal') modal: ModalDirective;
    @ViewChild('changeQuestionAnswerModal') questionModal: ModalDirective;

    public settingGroups: DataArray<AccountSettingGroup> = new DataArray<AccountSettingGroup>(1);
    public securityQuestions: SecurityQuestion[] = [];
    public question: SecurityQuestion = new SecurityQuestion();
    public questionAnswer = '';
    public expandedGroup = 0;
    public oldPassword = '';
    public newPassword = '';
    public validatePassword = '';
    public startPage = '';

    private subscriptions: Subscription[] = [];

    constructor(
        private _ngZone: NgZone,
        private _authorizationService: AuthorizationService,
        private _accountService: AccountService,
        private _toastrService: ToastrService
    ) {
        this.subscriptions.push(this._accountService.accountSettingGroupsChange.subscribe((groups: AccountSettingGroup[]) => {
            this._ngZone.run(() => {
                for (const group of groups) {
                    this.settingGroups.update(group, true);
                }
            });
        }));
        this.subscriptions.push(this._accountService.accountSettingsChange.subscribe((settings: AccountSettingGroup) => {
            this.settingGroups.update(settings, false, settings.Id);
        }));
        this.subscriptions.push(this._accountService.securityQuestionsChanged.subscribe((questions: SecurityQuestion[]) => {
            this._ngZone.run(() => {
                this.securityQuestions = questions;
            })
        }));

        this.startPage = this._authorizationService.startPage;
    }

    public changePassword(): void {
        this.modal.show();
    }

    public close(): void {
        this.oldPassword = '';
        this.newPassword = '';
        this.validatePassword = '';
        this.modal.hide();
    }

    public commitChangePassword(): void {
        this._accountService.changePassword(this._authorizationService.userId, this.oldPassword, this.newPassword);
        this.close();
    }

    public clearAnswer(): void {
        this._accountService.clearAnswer(this._authorizationService.userId, this.question.Id);
        this.questionModal.hide();
    }

    public closeQuestionModal(): void {
        this.questionModal.hide();
    }

    public commitChangeQuestionAnswer(): void {
        this._accountService.changeQuestionAnswer(this._authorizationService.userId, this.question.Id, this.questionAnswer);
        this.questionModal.hide();
    }

    public changeAnswer(question: SecurityQuestion): void {
        this.questionAnswer = '';
        this.question = question;
        this.questionModal.show();
    }

    public expand(groupId: number) {
        this._ngZone.run(() => {
            if (this.expandedGroup == groupId) {
                this.expandedGroup = 0;
            } else {
                this._accountService.getSettings(groupId, this._authorizationService.userId);
                this.expandedGroup = groupId;
            }
        })
    }

    public setHomePage() {
        this._accountService.setStartPage(this._authorizationService.userId, this.startPage);
    }

    public toggle(setting: AccountSetting) {
        this._accountService.toggleSetting(this._authorizationService.userId, setting.Id);
    }

    public enalbed(settingId: number): Promise<boolean> {
        return this._accountService.isEnabled(this._authorizationService.userId, settingId).then((result: boolean) => {
            return result;
        });
    }

    ngOnInit() {
        this._accountService.getGroups();
        this._accountService.getSecurityQuestions(this._authorizationService.userId);
        this.startPage = this._authorizationService.startPage;
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    public hasPermission(area: string): boolean {
        return this._authorizationService.hasPermission(area);
    }
}
